import React from 'react';
import styles from './LinkAccountCompletePanel.module.css';
import components from '../../../../resources/styles/components.module.css';
import { InnocodeButton } from '@intsoft/innocode-core';

function LinkAccountCompletePanel({ onComplete , provider}) {
    const providerNames = {
    'naver': '네이버',
    'kakao': '카카오',
    'google': 'Google',
    'apple': 'Apple'
  };

  const providerName = providerNames[provider] || '간편로그인';

  return (
    <>
      <div className={styles.signup_section}>
        <div className={styles.success_content}>
          <div className={styles.icon_box}>
            <img
              src="/assets/circles_success-icon.svg"
              alt="success-icon"
              className={styles.success_icon}
            />
          </div>
          <div className={`innocode-typography--title-lg innocode-typography--bold ${styles.title_text}`}>
            가입하신 계정을
            <br />
            {providerName} 계정과 연동했어요!
          </div>
          <div className={`innocode-typography--body-md-reading innocode-typography--regular ${styles.description_text}`}>
            이제 간편 로그인을 통해 서비스를
            <br />
            편리하게 이용해보세요!
          </div>
        </div>
      </div>
      <div className={styles.submit_btn_container}>
        <InnocodeButton size="lg" onClick={onComplete} designType={'primary'} theme={'solid'} className={styles.submit_btn}>
          완료
        </InnocodeButton>
        {/* <button
          type="button"
          className={`${components.btn} ${components.btn_solid} ${components.btn_primary} ${components.btn_lg} ${styles.submit_btn}`}
          onClick={onComplete}
        >
          <span className={components.btn__text}>완료</span>
        </button> */}
      </div>
    </>
  );
}

export default LinkAccountCompletePanel;
